export default __webpack_public_path__ + "static/media/1243.0ef1234c.png";